module.exports = "/_next/static/images/UDJ1-dcb79ed14990b431388e48d404552064.svg";